import React, {useEffect, useRef} from 'react'
import styles from './UIGameCardAnimatorItem.module.scss'
import {UIGameCard, UIGameCardProps} from '../../common/UIGameCard'
import {getDistance} from '@colonist/utils'
import {useUIGameCardAnimatorContext} from './UIGameCardAnimatorContext'

interface Point {
    x: number
    y: number
}

export interface UIGameCardAnimatorItemProps {
    id: number
    card: UIGameCardProps
    from: Point
    to: Point
    speed: number
    delay?: number
    onComplete?: (id: number) => void
}

export const UIGameCardAnimatorItem = ({
    id,
    card,
    from,
    to,
    speed,
    delay,
    onComplete,
}: UIGameCardAnimatorItemProps) => {
    const {itemSize} = useUIGameCardAnimatorContext()
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const element = ref.current
        if(!element) return

        element.style.transform = `translate(${from.x}px, ${from.y}px)`
        void element.offsetWidth // force layout recalculation

        const distance = getDistance(from, to)
        const duration = distance / speed

        element.style.transition = `transform ${duration}ms linear ${delay}ms`
        element.style.transform = `translate(${to.x}px, ${to.y}px)`

        const onTransitionEnd = () => {
            onComplete?.(id)
        }

        element.addEventListener('transitionend', onTransitionEnd)

        return () => {
            element.removeEventListener('transitionend', onTransitionEnd)
        }
    }, [id, from, to, speed, delay, onComplete])

    return (
        <div ref={ref} className={styles.container} style={{height: itemSize * 0.8}}>
            <UIGameCard {...card} />
        </div>
    )
}
